import {
  GoogleAuthProvider,
  // OAuthProvider,
  // getRedirectResult,
  signInWithPopup,
  // signInWithRedirect,
} from 'firebase/auth';
import { auth } from '../../config/firebase';
import { isGoogleSignInConfigured, OAUTH_CONFIG } from '../../config/oauthConfig';

const POPUP_CANCELLED_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

// Web uses Google sign-in only. Apple is enabled on native iOS (expo-apple-authentication).
// const APPLE_OAUTH_HANDLER =
//   'https://goalmint-d68e6.firebaseapp.com/__/auth/handler';

// function createAppleProvider(): OAuthProvider {
//   const provider = new OAuthProvider('apple.com');
//   provider.addScope('email');
//   provider.addScope('name');
//   return provider;
// }

/** Web: Apple redirect flow disabled (Google-only on web). */
export async function consumeAppleRedirectSignIn(): Promise<unknown | null> {
  return null;
  /*
  try {
    const result = await getRedirectResult(auth);
    if (result?.user) {
      console.log('[Apple sign-in] Redirect completed successfully');
      return result.user;
    }
  } catch (err) {
    const firebaseErr = err as { code?: string; message?: string };
    console.error('[Apple sign-in] Redirect failed:', firebaseErr.code, firebaseErr.message);
    throw err;
  }
  return null;
  */
}

export async function signInWithGoogle(): Promise<unknown> {
  if (!isGoogleSignInConfigured()) {
    throw new Error(
      'Google sign-in is not configured. Set EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID in .env.'
    );
  }

  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });

  const result = await signInWithPopup(auth, provider);
  return result.user;
}

/** Web: Apple Sign-In disabled — use Google or email/password on web. */
export async function signInWithApple(): Promise<unknown> {
  throw new Error('Sign in with Apple is not available on web. Use Google or email instead.');
  /*
  const provider = createAppleProvider();
  const useRedirect =
    typeof navigator !== 'undefined' &&
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  try {
    if (useRedirect) {
      await signInWithRedirect(auth, provider);
      return null;
    }
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (err) {
    const firebaseErr = err as { code?: string; message?: string };
    console.error('[Apple sign-in]', firebaseErr.code, firebaseErr.message);
    if (__DEV__ && firebaseErr.message?.includes('invalid_client')) {
      console.error(
        '[Apple sign-in] Web OAuth fix: Firebase → Authentication → Apple → OAuth code flow. ' +
          `Return URL must be ${APPLE_OAUTH_HANDLER}`
      );
    }
    const code = firebaseErr.code ?? '';
    if (code === 'auth/popup-blocked') {
      await signInWithRedirect(auth, provider);
      return null;
    }
    throw err;
  }
  */
}

export function isAppleSignInAvailable(): boolean {
  return false;
}

export function getGoogleConfigHint(): string {
  return OAUTH_CONFIG.googleWebClientId
    ? ''
    : 'Add EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID to your .env file.';
}

export function isGoogleSignInCancelled(error: unknown): boolean {
  const err = error as { code?: string };
  return POPUP_CANCELLED_CODES.has(err?.code ?? '');
}

export function isAppleSignInCancelled(error: unknown): boolean {
  return isGoogleSignInCancelled(error);
}
